import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
const uuid = require('uuid');

const SiteConfigStore = require('../../stores/SiteConfigStore');
const SiteConfigActions = require('../../actions/SiteConfigActions');
import Tooltip from '../common/Tooltip';

const propTypes = {
    className: PropTypes.string
};
const defaultProps = {
    className: ''
};
class SiteFeaturesEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            siteFeatures: [],
            actionId: null,
            error: null,
        }

        this.unsubscribes = [SiteConfigStore.listen(this.onSiteConfigStoreStateChange.bind(this))];
    }

    componentDidMount() {
        SiteConfigActions.getSiteFeatures(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSiteConfigStoreStateChange(state) {
        const initNoError = state.siteFeatures && !state.action.error;
        let additionalState = {};

        if (state.action.id === this.state.actionId) {
            additionalState = { ...additionalState, actionId: null };
        }

        this.setState({
            siteFeatures: state.siteFeatures,
            ...additionalState
        });
    }

    render() {
        return (
            <div className={this.props.className}>
                <Card body bg="light">
                    <h2 className="heading-lg">Site Features</h2>
                    <p className="margin-bottom-lg">Read-Only</p>
                    {(!!this.state.siteFeatures && this.state.siteFeatures.map((feature) => {
                        return (
                            <div key={feature.token}>
                                <span>{feature.token}</span>
                                {(!!feature.display_name) && <Tooltip id={`sf-${feature.token}`} className="margin-left-sm" placement="top">{feature.display_name}</Tooltip>}
                                <input className="margin-left-sm" type="checkbox" checked={feature.enabled} readOnly/>
                            </div>
                        );
                    }))}
                </Card>
            </div>
        );
    }
}

SiteFeaturesEditor.propTypes = propTypes;
SiteFeaturesEditor.defaultProps = defaultProps;

export default SiteFeaturesEditor;